
import '../styles/home.scss'
import { Candidata } from '../componentes/Candidata'
import { FooterCandidataHome } from '../componentes/FooterCandidataHome'
import { useCandidatas } from '../hooks/useCandidatas'
import { Header } from '../componentes/Header'
import { useEffect, useState } from 'react'
import { useLoading } from '../componentes/LoadingContext'
import { Countdown } from '../componentes/Countdown'
import api from '../services/api'
import { toast } from 'react-toastify'

export function Home() {

    const { candidatas } = useCandidatas()
    const { setLoading } = useLoading()
    const [status, setStatus] = useState<number>(1);
    const [time, setTime] = useState<Date>(new Date());
    const [msg, setMsg] = useState<string>('');

    useEffect(() => {
        const carregaDados = async () => {
            api.get("candidatas/rankingCandidatas")
                .then((response) => {

                    setStatus(response.data.status)
                    setTime(new Date(response.data.datafinal))
                    setMsg(response.data.msg)
                })
                .catch((e) => {
                    if (e.response) {
                        // Is this the correct way?
                        toast.error(e.response?.data.error)
                        localStorage.clear()
                    }
                })
        }
        carregaDados()
        setLoading(true);
        const timeout = setTimeout(() => setLoading(false), 1000)
        return () => {
            setLoading(false)
            clearTimeout(timeout)
        }
    }, [setLoading])

    return (

        <div id="page-room">
            <Header />
            {status === 0 && (
                <main className='content'>
                    <Countdown time={time} msg={msg} ></Countdown>
                </main>
            )}
            {status === 1 && (
                <main className='content'>
                    <div className='home-title'>
                        <h1>Escolha sua candidata:</h1>
                    </div>
                    <div className='question-list'>
                        <div className='list-flex'>
                            {candidatas.map(candidata => {
                                return (
                                    <Candidata key={candidata.id}
                                        content={candidata}>
                                        <FooterCandidataHome candidata={candidata} />
                                    </Candidata>
                                )
                            })}
                        </div>
                    </div>

                </main>
            )}
        </div>
    )
}